export default __webpack_public_path__ + "static/media/website_black_icon.ff47b0ac.svg";